<template>
  <SpinningLogo />
</template>

<script>
import SpinningLogo from '@/components/SpinningLogo';
import { apiService } from '@/utils/api/index';

export default {
  components: {
    SpinningLogo,
  },
  async created() {
    const data = {
      userPk: this.$route.params.userId,
    };

    try {
      const res = await apiService.post(
        `${process.env.VUE_APP_ROOT_API}users/confirm/user/email/`,
        data
      );

      if (res.status < 400 && !res.data.error) {
        this.$store.dispatch('showUserMessage', {
          success: true,
          message: 'Email verified!',
          persist: true,
        });
        setTimeout(() => {
          window.location.replace(process.env.VUE_APP_AUTH0_REDIRECT);
        }, 750);
      } else {
        this.$router.push({ path: `/partners` });
        this.$store.dispatch('showUserMessage', {
          success: false,
          message:
            res.data.error ||
            res.data.message ||
            'Oops! Something went wrong on our end. Error Code: 04',
        });
      }
    } catch (e) {
      if (e.data) {
        this.$store.dispatch('showUserMessage', {
          message:
            e.data.message ||
            'Oops! Something went wrong on our end. Error Code: 05',
          success: false,
          persist: true,
        });
      } else {
        this.$store.dispatch('showUserMessage', {
          message: 'Oops! Something went wrong on our end. Error Code: 06',
          success: false,
          persist: true,
        });
      }
    }
  },
};
</script>
